import { BADGE_SIZE } from "./constants";
export var getPreparedStringData = function getPreparedStringData(str, index, isEllipsis) {
  var isLong = str.length > index;
  var res = str;
  if (isLong) {
    res = "".concat(str.slice(0, index));
  }
  if (isEllipsis && isLong) {
    res = "".concat(str.slice(0, index - 3), "...");
  }
  return {
    isLong: isLong,
    string: res
  };
};
export var getImgMargin = function getImgMargin(badgesLength) {
  return {
    paddingTop: "".concat(BADGE_SIZE * badgesLength, "px")
  };
};
export var getBadgesLength = function getBadgesLength(device) {
  var _device$promoBadges;
  return Array.isArray(device === null || device === void 0 ? void 0 : device.promoBadges) && (device === null || device === void 0 ? void 0 : (_device$promoBadges = device.promoBadges) === null || _device$promoBadges === void 0 ? void 0 : _device$promoBadges.length) || 0;
};